<template lang="pug">
  validation-provider(
    :rules="rules"
    :name="label"
    :vid="vid"
    v-slot="{ errors, valid }"
  )
    v-subheader(style="font-size:1rem") {{ label }}
    editor(
      v-if="active"
      :value="value"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @onInit="$emit('activate')"
      :ref="vid"
      :init="config"
    )
    div(
      v-if="errors.length"
      class="v-messages v-messages__message error--text pl-3 mt-2"
    ) {{ errors[0] }}
</template>

<script>
import { getBase64 } from '@/utils/base64';
import Editor from '@tinymce/tinymce-vue';

export default {
  name: 'RichTextEditor',
  components: {
    Editor,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    rules: {
      type: [String, Object],
      required: false,
      default: '',
    },
    vid: {
      type: String,
      required: true,
      default: '',
    },
    label: {
      type: String,
      required: true,
      default: '',
    },
  },
  data: () => ({
    active: false,
    // config: {
    //   plugins: 'lists paste table',
    //   language_url: '/tinymce/langs/ru.js',
    //   height: 300,
    //   paste_as_text: true,
    // },
  }),
  computed: {
    config() {
      return {
        file_picker_callback: (callback) => {
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');

          input.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            const base64 = await getBase64(file);
            // const formData = new FormData();
            // formData.append('file', file);
            // const { data } = await this.$api.system.uploadFiles(formData);

            callback(base64, { title: file.name });
          });

          input.click();
        },
        file_picker_types: 'image',
        images_file_types: 'jpg,svg,webp,png',
        plugins: 'lists paste table, image',
        language_url: '/tinymce/langs/ru.js',
        height: 300,
        paste_as_text: true,
      };
    },
  },
  mounted() {
    this.$nextTick(() => { this.active = true; });
  },
};
</script>

<style lang="scss" scoped>
::v-deep .mce-tinymce {
  padding: 10px;
  border-radius: 28px;
  border: none;
  overflow: hidden;
}
</style>
